import React from "react";
import { Button, Card, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PaymentInProgress = (preps) => {
  const { lang, trans } = preps;
  const { t } = useTranslation();

  return (
    <>
      <Card className='d-flex align-items-center justify-content-center flex-wrap'>
        <div className='mt-4 mb-4'>
          <h2>{t("payment_in_progress")}</h2>
        </div>
        <div className='mb-3'>{t("status-inprogress-text")}</div>
        <Row className='my-3'>
          <NavLink to={"/payment/" + trans + "?lang=" + lang}>
            <Button color='danger' size='sm' className='mt-4 mb-4'>
              {t("select-now")}
            </Button>
          </NavLink>
        </Row>
      </Card>
    </>
  );
};

export default PaymentInProgress;
